import './bootstrap.css'
import './App.css';

import React, { useState, useEffect, useRef   } from 'react';

import tz_lookup from 'tz-lookup'
import moment from 'moment-timezone'

import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

import swal from 'sweetalert'

import PrayTimesTable from "./components/PrayTimesTable";
import LocationSearchInput from "./components/LocationSearchInput"
import OptionsForm from "./components/OptionsForm"



class App extends React.Component {

    prayTimesTableRef = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            timeZone: 0,
            format: '12hNS',
            address: '',
            dst : 0,
            method : 'ISNA',
            asrMethod : 'Standard',
            style : 'style1',

            latLng: undefined,
            newAddress: '',

            prayTimesTableRendered: false
        };
    }

    handleSubmit = () => {
        if(this.state.latLng == undefined) {
            swal("Error!", "Please enter your City or Zip Code first.", "warning");
        } else {
            this.setState({
                prayTimesTableRendered: true,
                lat: this.state.latLng.lat,
                lng: this.state.latLng.lng,
                address: this.state.newAddress,
                timeZone: moment.tz.zone(
                        tz_lookup(
                            this.state.latLng.lat,
                            this.state.latLng.lng)
                    ).utcOffset(moment())/-60,
            });
        }
    }
    handleChange = (state) => {
        this.setState(state)
    }
    handleSearchChange = (value) => {
        this.setState({
            prayTimesTableRendered: false,
            latLng: undefined,
            newAddress: ''
        });
    }
    handleSelect = (platLng,paddress) => {
        this.setState({
            latLng: platLng,
            newAddress: paddress
        });
    }

    render() {

        let prayTimesTable;
        if(this.state.prayTimesTableRendered) {
            prayTimesTable = <PrayTimesTable style={this.state.style} ref={this.prayTimesTableRef} date={new Date("2021-04-13")} lat={this.state.lat} lng={this.state.lng} 
            timeZone={this.state.timeZone} address={this.state.address} dst={this.state.dst} method={this.state.method} asrMethod={this.state.asrMethod} format={this.state.format}  />
        } else {
            prayTimesTable = <div></div>
        }

        return (
            <div>
            <Container className="header">
                <Row>
                    <Col>
                        <div className="text-center p-2">
                            <img src={process.env.PUBLIC_URL+"/images/logo-header.webp?ver="+window.settings.ver} alt="Islami City Logo"/>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col><h3 className="text-center p-2">Ramadan Prayer Times</h3></Col>
                </Row>
                <Row className="p-2">
                    <Col md={{ span: 4, offset: 4 }} sm={10} xs={10}>
                        <LocationSearchInput onSelect={this.handleSelect} onChange={this.handleSearchChange} />
                    </Col>
                    <Col sm={2} xs={2}>
                        <button className="btn btn-primary" onClick={this.handleSubmit}>Go</button>
                    </Col>
                </Row>
                <Row className="p-2">
                    <Col>
                        <OptionsForm printTableRef={this.prayTimesTableRef} onChange={this.handleChange} disabled={!this.state.prayTimesTableRendered} />
                    </Col>
                </Row>
                <Row>
                    <Col>
                    </Col>
                </Row>
            </Container>
            
            <div className="content">
                {prayTimesTable}
            </div>
            </div>
        );
    }
}

export default App;
